export default __webpack_public_path__ + "static/media/PROJECT 5.7dd95aea.png";